import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DetailComponent } from 'pmv-common';
import { PMVAuthenticationService } from 'pmv-common';
import { Inscricao } from '../../../models/inscricao-model';
import { RouteNavigationService } from '../../../services/api/route-navigation.service';

@Component({
  selector: 'pmv-desistir-convocacao',
  templateUrl: './desistir-convocacao.component.html',
  styleUrls: ['./desistir-convocacao.component.scss']
})

export class DesistirConvocacaoComponent extends DetailComponent implements OnInit {
  subtitle: string;
  loading: boolean = false;
  confirmarVerdadeInfo: boolean = false;
  editalAnoPss: string;
  inscricao: Inscricao;
  confirmarVerdadeiraOptions: any[];

  constructor(
    private routeDataService: RouteNavigationService,
    private route: ActivatedRoute,
    private authenticationService: PMVAuthenticationService
  ) { super(route); }

  handleValidSubmission(form: NgForm): void {
  }


  ngOnInit(): void {
    this.loading = true;
    const canActivate = this.authenticationService.isUserLoggedIn();
    if (canActivate) {
      const tk = this.authenticationService.getToken();
    } else {
      this.authenticationService.redirectToLoginPage();
      return;
    }

    this.subtitle = 'Leia o texto e selecione o de acordo para desistir da convocação... clique em Salvar.';
    this.getCarregarDadosInscricao();
    this.loading = false;
  }

  getCarregarDadosInscricao() {
    this.inscricao = this.routeDataService.getDataDesistirConvocacao();
    if (!this.inscricao) {
      this.loading = false;
      throw 'Error ao tentar recuperar dados da inscrição.';
    }

    this.editalAnoPss = 'Edital ' + this.inscricao.anoNumeroEdital + ' - ' + this.inscricao.cargoFuncao;
    this.confirmarVerdadeiraOptions = [
      { label: 'Declaro que as informações são verdadeiras.', value: true }
    ];
  }

  voltar(): void {
    this.routeDataService.toCandidatoConvocado();
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/desistir/desistir-convocacao.component.ts